// export const API_URL = 'http://localhost:8000/api';
export const API_URL = 'https://apply-backend.futurense.com/api';

